import { createListSearchParams, ListPagination } from 'api/list-params'
import { pipe } from 'fp-ts/function'
import {
  decodeJson,
  decodeJsonWithTotal,
  del,
  get,
  post,
  put,
} from 'lib/request'

import {
  PlanInterval,
  TCharge,
  TCreatedPaymentMethod,
  TPlan,
} from './plan.codecs'

export const createRequestToUpgradePlan = async ({
  message,
  planId,
}: {
  message: string
  planId?: string
}) => {
  return pipe(
    await post('api/plan/upgrade', {
      body: {
        message,
        planId,
      },
    }),
  )
}

export type GetPlansInput = {
  pagination: ListPagination
}

export const getPlans = async ({ pagination }: GetPlansInput) => {
  const params = createListSearchParams({ pagination })

  return pipe(
    await get('api/plans/available', { query: params }),
    decodeJsonWithTotal(TPlan, pagination),
  )
}

export type GetPlanDetailsInput = {
  planId: string
}

export const getPlanDetails = async ({ planId }: GetPlanDetailsInput) => {
  return pipe(
    await get(`api/plans/:planId`, { params: { planId } }),
    decodeJson(TPlan),
  )
}

export const createPaymentMethod = async () => {
  return pipe(
    await post('api/payment_methods', {}),
    decodeJson(TCreatedPaymentMethod),
  )
}

export type GetChargesInput = {
  pagination: ListPagination
}

export const getCharges = async ({ pagination }: GetChargesInput) => {
  const params = createListSearchParams({ pagination })

  return pipe(
    await get('api/charges', { query: params }),
    decodeJsonWithTotal(TCharge, pagination),
  )
}

type SubscribeToPlanInput = {
  planId: string
  interval: PlanInterval
  payload: string
  paymentMethodId: string
}

export const subscribeToPlan = async ({ ...body }: SubscribeToPlanInput) => {
  return await post(`api/subscriptions`, {
    body,
  })
}

export const updateSubscription = async ({ planId }: SubscribeToPlanInput) => {
  return await put(`api/subscriptions`, {
    body: {
      planId,
    },
  })
}

export const cancelSubscription = async () => {
  return await del(`api/subscriptions`, {})
}
